module.exports = __webpack_public_path__ + "img/warning1.7c8e5369.svg";